<template>
    <div class="container">
        <div class="reset-all-styles" v-html="page.content"></div>
    </div>
</template>

<script>
import {get} from '@/lib/axios';

export default {
    name: 'WorkRules',
    data: () => ({
        type: 7,
        page: {},
    }),
    methods: {
        async fetchData() {
            await get('static-page/' + this.type).then(response => {
                this.page = response.data.data
            })
        }
    },
    mounted() {
        this.fetchData()
    },
    metaInfo() {
        return {
            title: `Правила работы - ЛУКМАРКЕТ`,
        }
    },
}
</script>

<style scoped>

</style>
